'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeObserverPolyfill = require('resize-observer-polyfill');

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Shamelessly ripped off Modal.js.  There's probably a better way
// of doing reusable widgets like dialog boxes & menus where we go and
// pass in a custom control as the actual body.

function getContainer(containerId) {
    return document.getElementById(containerId);
} /*
  Copyright 2018 New Vector Ltd.
  
  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
  */

function getOrCreateContainer(containerId) {
    var container = getContainer(containerId);

    if (!container) {
        container = document.createElement("div");
        container.id = containerId;
        document.body.appendChild(container);
    }

    return container;
}

/*
 * Class of component that renders its children in a separate ReactDOM virtual tree
 * in a container element appended to document.body.
 *
 * This prevents the children from being unmounted when the parent of PersistedElement
 * unmounts, allowing them to persist.
 *
 * When PE is unmounted, it hides the children using CSS. When mounted or updated, the
 * children are made visible and are positioned into a div that is given the same
 * bounding rect as the parent of PE.
 */

var PersistedElement = function (_React$Component) {
    (0, _inherits3.default)(PersistedElement, _React$Component);

    function PersistedElement() {
        (0, _classCallCheck3.default)(this, PersistedElement);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PersistedElement.__proto__ || (0, _getPrototypeOf2.default)(PersistedElement)).call(this));

        _this.collectChildContainer = _this.collectChildContainer.bind(_this);
        _this.collectChild = _this.collectChild.bind(_this);
        _this._repositionChild = _this._repositionChild.bind(_this);
        _this._onAction = _this._onAction.bind(_this);

        _this.resizeObserver = new _resizeObserverPolyfill2.default(_this._repositionChild);
        // Annoyingly, a resize observer is insufficient, since we also care
        // about when the element moves on the screen without changing its
        // dimensions. Doesn't look like there's a ResizeObserver equivalent
        // for this, so we bodge it by listening for document resize and
        // the timeline_resize action.
        window.addEventListener('resize', _this._repositionChild);
        _this._dispatcherRef = _dispatcher2.default.register(_this._onAction);
        return _this;
    }

    /**
     * Removes the DOM elements created when a PersistedElement with the given
     * persistKey was mounted. The DOM elements will be re-added if another
     * PeristedElement is mounted in the future.
     *
     * @param {string} persistKey Key used to uniquely identify this PersistedElement
     */


    (0, _createClass3.default)(PersistedElement, [{
        key: 'collectChildContainer',
        value: function collectChildContainer(ref) {
            if (this.childContainer) {
                this.resizeObserver.unobserve(this.childContainer);
            }
            this.childContainer = ref;
            if (ref) {
                this.resizeObserver.observe(ref);
            }
        }
    }, {
        key: 'collectChild',
        value: function collectChild(ref) {
            this.child = ref;
            this.updateChild();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateChild();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.updateChild();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.updateChildVisibility(this.child, false);
            this.resizeObserver.disconnect();
            window.removeEventListener('resize', this._repositionChild);
            _dispatcher2.default.unregister(this._dispatcherRef);
        }
    }, {
        key: '_onAction',
        value: function _onAction(payload) {
            if (payload.action === 'timeline_resize') {
                this._repositionChild();
            }
        }
    }, {
        key: '_repositionChild',
        value: function _repositionChild() {
            this.updateChildPosition(this.child, this.childContainer);
        }
    }, {
        key: 'updateChild',
        value: function updateChild() {
            this.updateChildPosition(this.child, this.childContainer);
            this.updateChildVisibility(this.child, true);
        }
    }, {
        key: 'updateChildVisibility',
        value: function updateChildVisibility(child, visible) {
            if (!child) return;
            child.style.display = visible ? 'block' : 'none';
        }
    }, {
        key: 'updateChildPosition',
        value: function updateChildPosition(child, parent) {
            if (!child || !parent) return;

            var parentRect = parent.getBoundingClientRect();
            (0, _assign2.default)(child.style, {
                position: 'absolute',
                top: parentRect.top + 'px',
                left: parentRect.left + 'px',
                width: parentRect.width + 'px',
                height: parentRect.height + 'px'
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var content = _react2.default.createElement(
                'div',
                { ref: this.collectChild, style: this.props.style },
                this.props.children
            );

            _reactDom2.default.render(content, getOrCreateContainer('mx_persistedElement_' + this.props.persistKey));

            return _react2.default.createElement('div', { ref: this.collectChildContainer });
        }
    }], [{
        key: 'destroyElement',
        value: function destroyElement(persistKey) {
            var container = getContainer('mx_persistedElement_' + persistKey);
            if (container) {
                container.remove();
            }
        }
    }, {
        key: 'isMounted',
        value: function isMounted(persistKey) {
            return Boolean(getContainer('mx_persistedElement_' + persistKey));
        }
    }]);
    return PersistedElement;
}(_react2.default.Component);

PersistedElement.propTypes = {
    // Unique identifier for this PersistedElement instance
    // Any PersistedElements with the same persistKey will use
    // the same DOM container.
    persistKey: _propTypes2.default.string.isRequired
};
exports.default = PersistedElement;
module.exports = exports['default'];
//# sourceMappingURL=PersistedElement.js.map